export default __webpack_public_path__ + "static/media/icon_arrow_left.e94d41df.svg";